import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import GeneralCapitalCallsContent from './GeneralCapitalCallsContent';

const TransferGeneralCapitalActions: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
  stepper: React.ReactNode;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious, stepper }) => {
  const { selectedVehicleId } = useLayoutContext();

  const [generalCapitalActions] =
    api.partnerTransfers.getGeneralCapitalActions.useSuspenseQuery(
      {
        partnerTransferId,
        vehicleId: selectedVehicleId ?? '',
      },
      {
        staleTime: 0,
        gcTime: 0,
      },
    );

  return (
    <GeneralCapitalCallsContent
      partnerTransferId={partnerTransferId}
      generalCapitalActions={generalCapitalActions.map(
        (generalCapitalAction) => ({
          ...generalCapitalAction,
          newInvestorBreakdown: generalCapitalAction.newInvestorBreakdown ?? [],
        }),
      )}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
      stepper={stepper}
    />
  );
};

export default TransferGeneralCapitalActions;
